import React from "react";
import {FullNormativeArticleDialog} from "./FullNormativeArticleDialog";
import {NormativeArticleDialog} from "./NormativeArticleDialog";


export const Handbook = (
    {
        shadow,
        handbookName,
        isOpenNormativeArticleDialog,
        closeNormativeArticleDialog,
        searchText,
        handleSearchChange,
        normativeArticles,
        onNext,
        onNormativeArticleRowClick,
        isOpenFullNormativeArticleWindow,
        closeFullNormativeArticleWindow,
        selectedNormativeArticle,
        onCommitNormativeArticle,
        selectedDocument,
        normativeDocuments,
        closeAll,
        scrollRef
    }) => {

    return <>
        <NormativeArticleDialog shadow={shadow}
                       isOpenNormativeArticleDialog={isOpenNormativeArticleDialog}
                       closeNormativeArticleDialog={closeNormativeArticleDialog}
                       handbookName={handbookName}
                       searchText={searchText}
                       handleSearchChange={handleSearchChange}
                       normativeArticles={normativeArticles}
                       onNext={onNext}
                       scrollRef={scrollRef}
                       onNormativeArticleRowClick={onNormativeArticleRowClick}
                       normativeDocuments={normativeDocuments}
        />

        <FullNormativeArticleDialog isOpenFullNormativeArticleWindow={isOpenFullNormativeArticleWindow}
                                    closeFullNormativeArticleWindow={closeFullNormativeArticleWindow}
                                    closeAll={closeAll}
                                    handbookName={handbookName}
                                    selectedNormativeArticle={selectedNormativeArticle}
                                    selectedDocument={selectedDocument}
                                    onCommitNormativeArticle={onCommitNormativeArticle}
                                    normativeDocuments={normativeDocuments}
        />
    </>
}